var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"role-cell-container"},[_c('role-def-badge',{attrs:{"role-def":_vm.roleDef,"use-case":"team","loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }